const sendGtagEvent = (action, params = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, params);
  }
  // For development or if gtag is not available
  if (process.env.NODE_ENV === 'development') {
    console.log('GTag event:', { action, ...params });
  }
};

export default sendGtagEvent;
